import { Session } from 'smg/customer-api/session';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { GetFirstAndLast } from 'smg/users';

import * as buttons from 'smg/buttons';
import * as quoterequests from 'smg/customer-api/quoterequests';

import * as luxon from 'luxon';

import { Uploader } from '../components/uploader';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

if (document.body.id === 'rush-pin-quote-form') {
    main();
}

function main() {
    const $form = document.querySelector<HTMLFormElement>('#rush-quote-form') as HTMLFormElement;
    const $sectionSport = $form.querySelector<HTMLDivElement>('#section-sport') as HTMLDivElement;
    const $sectionShape = $form.querySelector<HTMLDivElement>('#section-shape') as HTMLDivElement;
    const $sectionPlating = $form.querySelector<HTMLDivElement>('#section-plating') as HTMLDivElement;
    const $sectionContact = $form.querySelector<HTMLDivElement>('#section-contact') as HTMLDivElement;

    const $fieldset = $form.querySelector<HTMLFieldSetElement>('#rush-quote-form-fieldset') as HTMLFieldSetElement;

    const $sportBaseball = $sectionSport.querySelector<HTMLInputElement>('#sport-baseball') as HTMLInputElement;
    const $sportSoftball = $sectionSport.querySelector<HTMLInputElement>('#sport-softball') as HTMLInputElement;

    const $platingGold = $sectionPlating.querySelector<HTMLInputElement>('#plating-gold') as HTMLInputElement;
    const $platingSilver = $sectionPlating.querySelector<HTMLInputElement>('#plating-silver') as HTMLInputElement;

    const $rushQuoteQuantity = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-quantity') as HTMLInputElement;
    const $rushQuoteProjectName = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-project-name') as HTMLInputElement;
    const $rushQuoteTeamName = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-team-name') as HTMLInputElement;
    const $rushQuoteTeamColors = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-team-colors') as HTMLInputElement;
    const $rushQuoteUploadLabel = $sectionContact.querySelector<HTMLLabelElement>('.uploader-dropzone') as HTMLLabelElement;
    const $rushQuoteNotes = $sectionContact.querySelector<HTMLTextAreaElement>('#rush-quote-notes') as HTMLTextAreaElement;
    const $rushQuoteName = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-name') as HTMLInputElement;
    const $rushQuoteEmail = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-email') as HTMLInputElement;
    const $rushQuotePhone = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-phone') as HTMLInputElement;
    const $rushQuoteDate = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-date') as HTMLInputElement;
    const $rushQuotePromo = $sectionContact.querySelector<HTMLInputElement>('#rush-quote-promo') as HTMLInputElement;

    const $rushQuoteFormSubmit = $form.querySelector<HTMLButtonElement>('#rush-quote-form-submit') as HTMLButtonElement;

    const uploader = new Uploader($rushQuoteUploadLabel);
    const phone = new Phone($rushQuotePhone);

    $sectionSport.addEventListener('click', () => {
        if ($sectionSport.querySelector('input:checked') && $sectionShape.classList.contains('d-none')) {
            $sectionShape.classList.remove('d-none');
            $sectionShape.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });

    $sectionShape.addEventListener('click', () => {
        if ($sectionShape.querySelector('input:checked') && $sectionPlating.classList.contains('d-none')) {
            $sectionPlating.classList.remove('d-none');
            $sectionPlating.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });

    $sectionPlating.addEventListener('click', () => {
        if ($sectionPlating.querySelector('input:checked') && $sectionContact.classList.contains('d-none')) {
            $sectionContact.classList.remove('d-none');
            $sectionContact.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $rushQuoteFormSubmit.addEventListener('click', e => {
        e.preventDefault();

        $rushQuoteDate.setCustomValidity('');
        let date: luxon.DateTime | undefined;
        if ($rushQuoteDate.value) {
            date = luxon.DateTime.fromJSDate(new Date($rushQuoteDate.value));
            if (date < luxon.DateTime.local()) {
                $rushQuoteDate.setCustomValidity('The date must be in the future.');
            }
        }

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($rushQuoteFormSubmit);
        const extras: quoterequests.Extra[] = [];
        extras.push({
            name: 'Team Name',
            value: $rushQuoteTeamName.value,
        });
        if ($rushQuoteTeamColors.value) {
            extras.push({
                name: 'Team Colors',
                value: $rushQuoteTeamColors.value,
            });
        }

        if ($sportBaseball.checked) {
            extras.push({
                name: 'Sport',
                value: 'Baseball',
            });
        } else if ($sportSoftball.checked) {
            extras.push({
                name: 'Sport',
                value: 'Softball',
            });
        }

        let shape;
        const $selectedShape = $sectionShape.querySelector<HTMLInputElement>('input[name="rush-quote-shape"]:checked');
        if ($selectedShape) {
            shape = $selectedShape.value;
        }

        let children: quoterequests.Child[] | undefined = [];

        if ($platingGold.checked) {
            children.push({
                child: 'Plating',
                option: 'Gold',
            });
        } else if ($platingSilver.checked) {
            children.push({
                child: 'Plating',
                option: 'Silver',
            });
        }

        if (!children.length) {
            children = undefined;
        }

        quoterequests.NewQuoteRequest({
            name: $rushQuoteName.value,
            company: $rushQuoteTeamName.value,
            phone,
            email: $rushQuoteEmail.value,
            lineItem: 'Lapel Pins',
            type: 'Made in USA - Rush Pins',
            size: shape,
            children,
            quantity: $rushQuoteQuantity.value ? parseInt($rushQuoteQuantity.value, 10) : undefined,
            promo: $rushQuotePromo.value ?? undefined,
            project: $rushQuoteProjectName.value ?? `${new Date().getFullYear()} ${$rushQuoteTeamName.value}` ?? undefined,
            dateNeeded: date?.toISODate() ?? undefined,
            notes: $rushQuoteNotes.value ?? undefined,
            extras,
            uploader,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String($rushQuoteName.value));
            dataLayer.push({
                'event': 'hs-module-quote-form-success',
                'userData': {
                    'email': sess?.email || $rushQuoteEmail.value,
                    'phone': sess?.phone || await phone.Format(),
                    'firstName': sess?.firstName || firstName,
                    'lastName': sess?.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });
            window.location.href = `${Relref('/free-quote/thank-you')}?id=${quoteRequest.quotes?.[0].key ?? ''}`;
        }).catch(err => {
            HandleRequestError(err);
            $fieldset.disabled = false;
            buttons.Stop($rushQuoteFormSubmit);
        });
        return;
    });
}